import React, { useState, useEffect } from 'react';

const isElectron = window && window.process && window.process.type;
const ipcRenderer = isElectron ? window.require('electron').ipcRenderer : null;

const UpdateBanner = () => {
    const [status, setStatus] = useState(null); // null | { status, version?, percent?, message? }
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (!ipcRenderer) return;

        const handler = (_event, data) => {
            setStatus(data);
            setDismissed(false);
        };

        ipcRenderer.on('updater-status', handler);
        return () => ipcRenderer.removeListener('updater-status', handler);
    }, []);

    if (!status || dismissed) return null;
    if (status.status === 'not-available' || status.status === 'checking') return null;

    const handleInstall = () => {
        if (ipcRenderer) ipcRenderer.send('install-update');
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                zIndex: 9999,
                background: 'var(--ink)',
                color: 'var(--ink-inverse, #fff)',
                padding: '12px 16px',
                borderRadius: 12,
                boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
                fontSize: 12,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                maxWidth: 360,
                animation: 'fadeIn 0.3s ease-out',
            }}
        >
            <div style={{ flex: 1 }}>
                {status.status === 'available' && (
                    <span>🔄 Update v{status.version} is available. Downloading…</span>
                )}
                {status.status === 'downloading' && (
                    <span>⬇️ Downloading update… {status.percent}%</span>
                )}
                {status.status === 'downloaded' && (
                    <span>✅ Update v{status.version} ready to install!</span>
                )}
                {status.status === 'error' && (
                    <span>⚠️ Update error: {status.message}</span>
                )}
            </div>

            {status.status === 'downloaded' && (
                <button
                    onClick={handleInstall}
                    style={{
                        background: 'var(--accent, #a3ed96)',
                        color: '#111',
                        border: 'none',
                        padding: '6px 14px',
                        borderRadius: 8,
                        fontSize: 11,
                        fontWeight: 700,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                    }}
                >
                    Restart Now
                </button>
            )}

            <button
                onClick={() => setDismissed(true)}
                style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'inherit',
                    opacity: 0.5,
                    cursor: 'pointer',
                    fontSize: 16,
                    lineHeight: 1,
                    padding: 0,
                }}
                aria-label="Dismiss"
            >
                ×
            </button>
        </div>
    );
};

export default UpdateBanner;
